import { useState, useEffect } from "react";
import Modal from "./Modal";
import BimLogo from "../../BimLogo";
import styles from "../../../styles/aprt.module.scss";

const HotSpotModal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className={styles.hotspot_modal}>
        {children}
        <div style={{textAlign: 'center'}}>
          Kliknij w obrazek aby zmienić inspirację stylu wykończenia. Grafika z widokiem wnętrza generowana przez AI.
        </div>
          <div className={styles.overlay_logo}
          style={{right:"10%", bottom:"1rem"}}>
            <BimLogo />
          </div>
      </div>
    </Modal>
  );
};

export default HotSpotModal;
